module.exports = __webpack_public_path__ + "img/icon-IN-HOSPITAL.cd6667c8.png";